import Hero from './components/Hero';
import Autoridade from './components/Autoridade';
import Beneficios from './components/Beneficios';
import OQueVoceRecebe from './components/OQueVoceRecebe';
import Diferencial from './components/Diferencial';
import OfertaEspecial from './components/OfertaEspecial';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <Autoridade />
      <Beneficios />
      <OQueVoceRecebe />
      <Diferencial />
      <OfertaEspecial />
      <FAQ />
      <CTAFinal />
      <Footer />
    </div>
  );
}
